import { T } from '@transifex/react';
import { Link } from 'react-router';

import { buttonVariants } from './ui/button';
import { PageContainer, SectionContainer } from './ui/container';

type ErrorPageLayoutProps = {
  title: string;
  description: string;
  actions: React.ReactNode;
  debugInfo?: React.ReactNode;
  image: React.ReactNode;
};

export function ErrorPageLayout({
  title,
  description,
  actions,
  debugInfo,
  image,
}: ErrorPageLayoutProps) {
  return (
    <>
      <PageContainer>
        <SectionContainer
          className="
            flex flex-col items-center gap-md rounded-lg bg-background-0 p-lg
          "
        >
          <div className="flex items-center justify-center rounded-lg">{image}</div>

          <h1 className="text-center text-h1 text-text-900">{title}</h1>

          <p className="text-center text-body-big text-text-700">{description}</p>

          {actions}
        </SectionContainer>
        {debugInfo}
      </PageContainer>
    </>
  );
}

type ErrorPageActionsProps = {
  children: React.ReactNode;
};

export function ErrorPageActions({ children }: ErrorPageActionsProps) {
  return <div className="flex flex-wrap justify-center gap-md">{children}</div>;
}

type BackToDashboardButtonProps = {
  variant?: 'outline' | 'default';
};

export function BackToDashboardButton({ variant = 'outline' }: BackToDashboardButtonProps) {
  return (
    <Link className={buttonVariants({ variant })} to="/">
      <T _str="Back to the dashboard" />
    </Link>
  );
}
